import { CareerBulkResponse, CareerListResponse, CareerResponse } from '../dto/ResDtoRepository';
import { CreateCareerReq, RemoveCareerReq, UpdateCareerBulkReq, UpdateCareerVisibilityReq, UpdateReorderListReq } from '../dto/ReqDtoRepository';
import { sendApiRequest, sendDeleteApiRequest, sendGetApiRequest } from './apiConfig';


export const getCareerList = async (aui: string): Promise<CareerListResponse> => {
  return sendGetApiRequest<CareerListResponse>(`/api/v1/career?aui=${aui}`);
};

export const getCareerListForOwner = async (aui: string): Promise<CareerListResponse> => {
  return sendApiRequest<CareerListResponse>('get', `/api/v1/career/owner?aui=${aui}`);
};

export const createCareer = async (aui: string, data: CreateCareerReq): Promise<CareerResponse> => {
  return sendApiRequest<CareerResponse>('post', `/api/v1/career?aui=${aui}`, data);
};

export const updateCareerBulk = async (aui: string, data: UpdateCareerBulkReq): Promise<CareerBulkResponse> => {
  return sendApiRequest<CareerBulkResponse>('put', `/api/v1/career/bulk?aui=${aui}`, data);
};

export const updateCareerVisibility = async (aui: string, data: UpdateCareerVisibilityReq): Promise<CareerResponse> => {
  return sendApiRequest<CareerResponse>('put', `/api/v1/career/visibility?aui=${aui}`, data);
};

export const deleteCareer = async (aui: string, data: RemoveCareerReq): Promise<CareerResponse> => {
  return sendDeleteApiRequest<CareerResponse>(`/api/v1/career?aui=${aui}&careerId=${data.careerId}`);
};

export const reorderCareer = async (aui: string, data: UpdateReorderListReq): Promise<CareerListResponse> => {
  return sendApiRequest<CareerListResponse>('put', `/api/v1/career/reorder?aui=${aui}`, data);
};